import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ExtendedListenableSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';

import { ingestProduct } from './ingress';
import { Product } from './entities';
import { ProductRestful } from './restful';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'product_error';
  type: 'error';
}

interface ProductsEvent {
  product: Product;
  type: 'get_product';
}

export type ProductRequestEvent = ErrorEvent | ProductsEvent;

interface ProductFunctions {
  getProduct: ProductRequest['getProduct'];
}

export class ProductRequest extends ExtendedListenableSubscribable<ProductRequestEvent, ProductFunctions> {
  private restful: ProductRestful;

  constructor(session: Session) {
    super();
    this.restful = new ProductRestful(session);
  }

  public getProduct = async (productName: string): SafePromise<Product> => {
    const product = await ingestProduct(this.restful.getProduct(productName));
    if (product.err) {
      this.dispatch({
        error: product.err,
        errorType: 'product_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        product: product.ok,
        type: 'get_product',
      });
    }
    return product;
  };

  protected onSubscribe(): ProductFunctions {
    return {
      getProduct: this.getProduct,
    };
  }
}
